import { Z_INDEX, type AnyTheme } from "../util/themes";

export const HEADER_STYLES = {
  fixedHeader: {
    display: "flex",
    alignItems: "center",
    px: 2,
    borderBottom: 1,
    borderColor: "grey.300",
    position: "fixed" as const,
    top: 0,
    left: 0,
    right: 0,
    bgcolor: "white",
    zIndex: Z_INDEX.header,
  },
  spacer: (height: string | number) => ({
    height,
    minHeight: '0 !important'
  })
} as const;

export const getHeaderStyles = (theme: AnyTheme) => {
  const isDarkTheme = theme.name === "dark";

  return {
    ...HEADER_STYLES,
    fixedHeader: {
      ...HEADER_STYLES.fixedHeader,
      bgcolor: isDarkTheme ? theme.colors.background.default : theme.colors.background.paper,
      borderColor: theme.colors.greyLight,
    },
  };
};














